<dx-button
  [VisibleForRoles]="['SUPERADMIN', 'ADMIN']"
  *ngIf="!redirectedFromWidget" [hint]="'upload-file' | translateWithFallback" stylingMode="outlined" class="ml-5 mt-15" (onClick)="openModal(templateBackUp)">
  <fa-icon [icon]="faUpload"></fa-icon>
</dx-button>

<dx-button *ngIf="redirectedFromWidget" stylingMode="outlined" class="ml-5 mt-15" (onClick)="back()">
  <fa-icon [icon]="faArrowBack"></fa-icon>
</dx-button>


<ng-template #templateBackUp>
  <div class="content-block dx-card responsive-paddings pt-35">
    <div class="modal-header align-self-center">
      <h6>{{'restore-machine-data-from-backup' | translateWithFallback}}</h6>
      <dx-button class="btn-close close pull-right" aria-label="Close" (click)="decline()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </dx-button>
    </div>

    <div class="modal-body text-center">
      <div [VisibleForRoles]="['SUPERADMIN']">
        <p>{{ 'you-want-to-change-owner' | translateWithFallback }}</p>

        <dx-select-box id="OwnerName" [labelMode]="'outside'" [label]="'owner' | translateWithFallback" [dataSource]="ownersDs" valueExpr="Name" displayExpr="Name" (onValueChanged)="changeOwnerBackup($event)"></dx-select-box>
      </div>

      <dx-button [type]="'normal'" [stylingMode]="'outlined'" class="mt-2" (click)="file.click()" [disabled]="loadIndicatorVisible">
        <dx-load-indicator
          class="button-indicator mr-2"
          [visible]="loadIndicatorVisible"
        />
        <span>
          {{ 'choose-file' | translateWithFallback }}
        </span>
        <input type="file" #file [placeholder]="'Choose file' | translateWithFallback" (change)="uploadFile(file.files!)" style="display:none;">
      </dx-button>
    </div>
  </div>
</ng-template>

<ng-template #templateUpload>
  <div class="content-block dx-card responsive-paddings pt-35">
    <div class="modal-body text-center">
      <div class="col-md-4">
        <span class="upload" *ngIf="progress > 0">
          {{progress}}%
        </span>
        <span class="upload" *ngIf="message">
          {{message}}
        </span>

        <span class="upload" *ngIf="!message">
          {{ 'machines-upload-file-upload-in-progress' | translateWithFallback }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="isSmallScreen; else largeScreen">
  <dx-data-grid
    id="gridContainer"
    [dataSource]="MiSvc.dataSource"
    keyExpr="Id"
    [columnAutoWidth]="true"
    [showBorders]="true"
    [remoteOperations]="true"
    [rowAlternationEnabled]="true"
    (onRowClick)="onRowClick($event)"
    dataRowTemplate="dataRowTemplateName"
    width="90%"
    style="margin: 0 auto;"
  >
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string" width="25%"></dxi-column>
    <dxi-column dataField="FenixVersion" [caption]="'version' | translateWithFallback" dataType="string" width="25%"></dxi-column>
    <dxi-column
      dataField="OwnerId" dataType="string" [caption]="'owner' | translateWithFallback" width="25%">
      <dxo-lookup [dataSource]="OSvc.AllOwners" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="CurrentStatus" dataType="string" [caption]="'state' | translateWithFallback" width="25%"></dxi-column>

    <tr *dxTemplate="let machineInfo of 'dataRowTemplateName'" role="row" [ngClass]="{ 'dx-row-alt': machineInfo.rowIndex % 2 === 0 }">
      <td colspan="4">
        <table width="100%" >
          <tr class="main-row" role="row">
            <td role="gridcell" width="10%">
              <dx-button stylingMode="text" (click)="show(machineInfo.rowIndex)">
                <fa-icon *ngIf="!isShowed[machineInfo.rowIndex]" [icon]="faAngleRight"></fa-icon>
                <fa-icon *ngIf="isShowed[machineInfo.rowIndex]" [icon]="faAngleDown"></fa-icon>
              </dx-button>
            </td>
            <td role="gridcell" width="50%">{{ machineInfo.data.Name }} ({{ getOwnerName(machineInfo.data.OwnerId) }})</td>
            <td role="gridcell" width="30%">{{ machineInfo.data.FenixVersion }}</td>
            <td role="gridcell" width="10%"><span *ngIf="this.MiSvc.CurrentMachine?.Id == machineInfo.data.Id">*</span></td>
          </tr>
          <tr *ngIf="isShowed[machineInfo.rowIndex]">
            <td colspan="4">
              <table width="100%">
                <tr class="main-row" role="row">
                  <td role="gridcell" colspan="2">{{ machineInfo.data.Name }} ({{ getOwnerName(machineInfo.data.OwnerId) }})</td>
                  <td role="gridcell" colspan="2">{{ machineInfo.data.FenixVersion }}</td>
                </tr>
                <tr class="notes-row" role="row">
                  <td role="gridcell" colspan="4">{{ machineInfo.data.CurrentStatus }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true"
      [showNavigationButtons]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[10, 25, 50, 100]">
    </dxo-pager>
  </dx-data-grid>
</ng-container>

<ng-template #largeScreen>
  <dx-data-grid
    id="machineInfoGrid"
    keyExpr="Id"
    [dataSource]="MiSvc.dataSource"
    [showBorders]="true"
    [remoteOperations]="true"
    [focusedRowEnabled]="true"
    [rowAlternationEnabled]="true"
    [focusedRowKey]="(MiSvc.actualMachine$ | async)?.Id"
    (onRowClick)="onRowClick($event)"
    [columnHidingEnabled]="true"
    width="90%"
    height="80vh"
    style="margin: 0 auto;"
    [columnAutoWidth]="true"
    >
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"> </dxi-column>
    <dxi-column [width]="250" dataField="FenixVersion" [caption]="'version' | translateWithFallback" dataType="string" [hidingPriority]="2">
    </dxi-column>
    <dxi-column [width]="250" dataField="OwnerId" dataType="string" [caption]="'owner' | translateWithFallback">
      <dxo-lookup [dataSource]="OSvc.AllOwners" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    </dxi-column>
    <dxi-column [width]="250" dataField="CurrentStatus" dataType="string" [caption]="'state' | translateWithFallback" [hidingPriority]="0">
    </dxi-column>
    <dxi-column [width]="50" cellTemplate="isCurrentMachineTemplate" [hidingPriority]="3" width="5%"></dxi-column>
    <div *dxTemplate="let data of 'isCurrentMachineTemplate'">
      <span *ngIf="this.MiSvc.CurrentMachineId == data.data.Id">*</span>
    </div>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
<!--    infinite scrolling breaks paginator-->
<!--    <dxo-scrolling rowRenderingMode="virtual" mode="infinite"> </dxo-scrolling>-->
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true"
      [showNavigationButtons]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[10, 25, 50, 100]">
    </dxo-pager>
  </dx-data-grid>
</ng-template>
